var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.167 13h1.667v1.666H9.167V13Zm0-6.667h1.667v5H9.167v-5Zm.825-4.167c-4.6 0-8.325 3.734-8.325 8.334s3.725 8.333 8.325 8.333c4.608 0 8.342-3.733 8.342-8.333S14.6 2.166 9.992 2.166Zm.008 15A6.665 6.665 0 0 1 3.334 10.5 6.665 6.665 0 0 1 10 3.833a6.665 6.665 0 0 1 6.667 6.667A6.665 6.665 0 0 1 10 17.166Z",
    fill: "current"
  })));
};
export default SvgInformation;